import moment from "moment";
import { avatarColor as chatAvatarColor, pollColorPresets } from "@/chat/chat.js";
const fb = require("@/firebaseConfig.js");

// Teachers plus the xDuties roles flagged isEmployee; students and parents use the app only.
export const APP_MENU_ROLES = [
  "teacher",
  "schooldirector",
  "schoolmanager",
  "schooladmin",
  "schooldoctor",
  "schoolsocialworker",
  "schoolpsychologist",
  "schoollibrarer",
  "schoolaccounter",
  "schoolaccounter2",
  "schoolmealcontroller",
  "schooldormitoryguard",
];

const sampleImage = (from, to) =>
  "data:image/svg+xml;charset=utf-8," +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 10"><defs><linearGradient id="g" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="${from}"/><stop offset="1" stop-color="${to}"/></linearGradient></defs><rect width="16" height="10" fill="url(#g)"/><circle cx="12.5" cy="3" r="1.4" fill="#fff" opacity=".8"/><path d="M0 10 L5 5 L8 8 L11 6 L16 10Z" fill="#fff" opacity=".35"/></svg>`
  );

const samplePosts = [
  {
    id: "s1",
    createdByName: "Б.Батаа",
    title: "Жишээ гарчиг — зурагтай агуулга",
    description: "Энэ бол жишээ текст. Цэсний загвар, өнгө, гарчгийн тохиргоо энд хэрхэн харагдахыг шалгана.",
    images: [sampleImage("#60a5fa", "#a78bfa")],
    links: [],
    createdAt: new Date(),
    totalLikes: 12,
    totalComments: 3,
  },
  {
    id: "s2",
    createdByName: "Д.Сараа",
    title: "Урт гарчигтай жишээ агуулга: гарчгийн мөрийн тоо, хэмжээ хэрхэн таслагдахыг харуулна",
    description: "Хоёр дахь жишээ. Линктэй агуулга ийм харагдана.",
    images: [sampleImage("#34d399", "#fbbf24")],
    links: [{ title: "Видео хичээл", url: "https://youtube.com/" }],
    createdAt: new Date(),
  },
  {
    id: "s3",
    createdByName: "Э.Тэмүүлэн",
    title: "Зураггүй жишээ",
    description: "Зураггүй, зөвхөн текст болон линктэй агуулга.",
    images: [],
    links: [{ title: "Google Drive материал", url: "https://drive.google.com/" }],
    createdAt: new Date(),
  },
  {
    id: "s4",
    createdByName: "Г.Номин",
    title: "Дөрөв дэх жишээ",
    description: "Grid загвар дээр олон карт хэрхэн байрлахыг харуулна.",
    images: [sampleImage("#f472b6", "#fb7185")],
    links: [],
    createdAt: new Date(),
  },
];

export default {
  data: () => ({
    samplePosts,
    weights: [400, 500, 600, 700],
    colorMenu: {},
    colorBackup: null,
    menuColorFields: [
      { key: "bgColor", label: "Drawer дээрх цэсний ар", fallback: "#EEF2F7" },
      { key: "textColor", label: "Drawer дээрх цэсний текст", fallback: "#1E293B" },
      { key: "appBarColor", label: "Толгойн өнгө", fallback: "#16A34A" },
      { key: "appBarTextColor", label: "Толгойн текст", fallback: "#FFFFFF" },
      { key: "pageBgColor", label: "Хуудасны өнгө", fallback: "#F3F4F6" },
      { key: "cardBgColor", label: "Картын өнгө", fallback: "#FFFFFF" },
      { key: "cardTextColor", label: "Картын текст", fallback: "#1E293B" },
    ],
    postColorFields: [
      { key: "bgColor", label: "Картын арын өнгө", fallback: "#FFFFFF" },
      { key: "textColor", label: "Картын текстийн өнгө", fallback: "#1E293B" },
    ],
    loading: true,
    saving: false,
    menus: [],
    filterSchool: null,
    filterRole: null,
    roleItems: [],
    staffItems: [],
    staffLoading: false,
    classGroupItems: [],
    authorPhotos: {},
    likedMap: {},
    myVotes: {},
    voting: false,
    pollPresets: [],
    commentText: "",
    sendingComment: false,
    schools: [],
    selected: null,
    contentDialog: false,
    posts: [],
    unsubMenus: null,
    unsubPosts: null,
    postTab: 0,
    postLimit: 30,
    commentLimit: 50,
    pollStats: null,
    commentsDialog: false,
    commentsPost: null,
    comments: [],
    unsubComments: null,
    menuDialog: false,
    menuForm: {
      id: null,
      name: "",
      bgColor: null,
      textColor: null,
      isPublic: false,
      roles: [],
      grades: [],
      byGroups: false,
      classGroups: [],
      adminIds: [],
      layout: "list",
      schoolId: null,
      needApproval: true,
      headerTitle: "",
      icon: "article",
      iconUrl: null,
      newIcon: null,
      gridColumns: 2,
      imageRatio: "wide",
      pageBgColor: null,
      cardBgColor: null,
      cardTextColor: null,
      titleSize: 16,
      titleWeight: 700,
      titleMaxLines: 2,
      appBarColor: null,
      appBarTextColor: null,
    },
    iconItems: [
      { key: "article", mdi: "mdi-text-box-outline" },
      { key: "book", mdi: "mdi-book-open-page-variant-outline" },
      { key: "library", mdi: "mdi-bookshelf" },
      { key: "school", mdi: "mdi-school-outline" },
      { key: "calendar", mdi: "mdi-calendar-month-outline" },
      { key: "clock", mdi: "mdi-clock-outline" },
      { key: "star", mdi: "mdi-star-outline" },
      { key: "info", mdi: "mdi-information-outline" },
      { key: "link", mdi: "mdi-link-variant" },
      { key: "video", mdi: "mdi-play-circle-outline" },
      { key: "youtube", mdi: "mdi-youtube" },
      { key: "image", mdi: "mdi-image-outline" },
      { key: "camera", mdi: "mdi-camera-outline" },
      { key: "folder", mdi: "mdi-folder-outline" },
      { key: "file", mdi: "mdi-file-document-outline" },
      { key: "drive", mdi: "mdi-google-drive" },
      { key: "web", mdi: "mdi-web" },
      { key: "bell", mdi: "mdi-bell-outline" },
      { key: "megaphone", mdi: "mdi-bullhorn-outline" },
      { key: "newspaper", mdi: "mdi-newspaper-variant-outline" },
      { key: "chat", mdi: "mdi-chat-outline" },
      { key: "forum", mdi: "mdi-forum-outline" },
      { key: "heart", mdi: "mdi-heart-outline" },
      { key: "flag", mdi: "mdi-flag-outline" },
      { key: "medal", mdi: "mdi-medal-outline" },
      { key: "trophy", mdi: "mdi-trophy-outline" },
      { key: "map", mdi: "mdi-map-marker-outline" },
      { key: "phone", mdi: "mdi-phone-outline" },
      { key: "mail", mdi: "mdi-email-outline" },
      { key: "cart", mdi: "mdi-cart-outline" },
      { key: "money", mdi: "mdi-cash" },
      { key: "gift", mdi: "mdi-gift-outline" },
      { key: "bulb", mdi: "mdi-lightbulb-outline" },
      { key: "help", mdi: "mdi-help-circle-outline" },
      { key: "home", mdi: "mdi-home-outline" },
      { key: "grid", mdi: "mdi-view-grid-outline" },
      { key: "list", mdi: "mdi-format-list-bulleted" },
      { key: "check", mdi: "mdi-check-circle-outline" },
      { key: "alert", mdi: "mdi-alert-circle-outline" },
      { key: "shield", mdi: "mdi-shield-outline" },
      { key: "lock", mdi: "mdi-lock-outline" },
      { key: "key", mdi: "mdi-key-outline" },
      { key: "settings", mdi: "mdi-cog-outline" },
      { key: "people", mdi: "mdi-account-group-outline" },
      { key: "person", mdi: "mdi-account-outline" },
      { key: "teacher", mdi: "mdi-human-male-board" },
      { key: "child", mdi: "mdi-human-child" },
      { key: "family", mdi: "mdi-account-multiple-outline" },
      { key: "health", mdi: "mdi-heart-pulse" },
      { key: "medical", mdi: "mdi-medical-bag" },
      { key: "food", mdi: "mdi-food-outline" },
      { key: "milk", mdi: "mdi-cup-outline" },
      { key: "bus", mdi: "mdi-bus" },
      { key: "sport", mdi: "mdi-basketball" },
      { key: "music", mdi: "mdi-music-note-outline" },
      { key: "art", mdi: "mdi-palette-outline" },
      { key: "science", mdi: "mdi-flask-outline" },
      { key: "math", mdi: "mdi-calculator-variant-outline" },
      { key: "globe", mdi: "mdi-earth" },
      { key: "chart", mdi: "mdi-chart-bar" },
      { key: "clipboard", mdi: "mdi-clipboard-text-outline" },
      { key: "edit", mdi: "mdi-pencil-outline" },
      { key: "qr", mdi: "mdi-qrcode" },
      { key: "download", mdi: "mdi-download-outline" },
      { key: "upload", mdi: "mdi-upload-outline" },
      { key: "leaf", mdi: "mdi-leaf" },
      { key: "sun", mdi: "mdi-white-balance-sunny" },
      { key: "snow", mdi: "mdi-snowflake" },
      { key: "fire", mdi: "mdi-fire" },
      { key: "rocket", mdi: "mdi-rocket-launch-outline" },
      { key: "puzzle", mdi: "mdi-puzzle-outline" },
      { key: "game", mdi: "mdi-gamepad-variant-outline" },
    ],
    postDialog: false,
    postForm: {
      id: null,
      title: "",
      description: "",
      links: [],
      images: [],
      newImages: [],
      bgColor: null,
      textColor: null,
      titleSize: "menu",
      titleMaxLines: "menu",
      titleWeight: "menu",
      isPublished: true,
      allowLikes: true,
      allowComments: true,
      status: null,
      pollOn: false,
      poll: { question: "", options: ["", ""], multiple: false, anonymous: false, showResults: false, closed: false },
    },
  }),
  computed: {
    isSuper() {
      const user = this.$store.state.userData;
      return !!user && (user.role === "superadmin" || user.role === "superadmin2");
    },
    mySchoolId() {
      const school = (this.$store.state.userData || {}).school;
      return this.isSuper ? null : (school && school.id) || null;
    },
    // Superadmins manage every school; others get in once their school turned the flag on.
    allowed() {
      if (this.isSuper) return true;
      const user = this.$store.state.userData || {};
      if (!APP_MENU_ROLES.includes(user.role)) return false;
      const school = user.school;
      return !!(this.mySchoolId && school.schoolDatas && school.schoolDatas.appMenusEnabled === true);
    },
    schoolItems() {
      return [{ id: null, name: "Бүх сургууль" }, ...this.schools];
    },
    filterSchoolItems() {
      return [{ id: "_all", name: "Бүх сургуулийн цэс" }, ...this.schools];
    },
    filteredMenus() {
      return this.menus.filter((m) => {
        if (this.filterSchool === "_all" && m.schoolId) return false;
        if (this.filterSchool && this.filterSchool !== "_all" && m.schoolId && m.schoolId !== this.filterSchool) return false;
        if (this.filterRole && (m.roles || []).length && !m.roles.includes(this.filterRole)) return false;
        return true;
      });
    },
    menuIconPreview() {
      const f = this.menuForm;
      return f.newIcon ? f.newIcon.preview : f.iconUrl || null;
    },
    myId() {
      const u = this.$store.state.userData || {};
      return u.id || (u.ref && u.ref.id) || "";
    },
    myPhoto() {
      return (this.$store.state.userData || {}).photoURL || "";
    },
    postCounts() {
      const p = this.posts;
      return {
        published: p.filter((x) => x.isPublished).length,
        pending: p.filter((x) => x.status === "pending").length,
        other: p.filter((x) => !x.isPublished && x.status !== "pending").length,
      };
    },
    tabPosts() {
      if (this.postTab === 1) return this.posts.filter((x) => x.status === "pending");
      if (this.postTab === 2) return this.posts.filter((x) => !x.isPublished && x.status !== "pending");
      return this.posts.filter((x) => x.isPublished);
    },
    previewPosts() {
      return this.posts
        .filter((p) => p.isPublished)
        .map((p) => ({ ...p, createdByPhotoUrl: this.photoOf(p) }));
    },
    // While the selected menu is being edited, the preview follows the dialog.
    previewMenu() {
      if (!this.selected) return null;
      if (this.menuDialog && this.menuForm.id === this.selected.id) {
        return { ...this.selected, ...this.menuForm };
      }
      return this.selected;
    },
    // Class teachers of the picked groups stay admins while the group is picked.
    lockedAdminIds() {
      return this.menuForm.byGroups ? this.classTeacherIds(this.menuForm.classGroups) : [];
    },
    gradesApply() {
      const r = this.menuForm.roles || [];
      return r.includes("_all") || r.includes("student") || r.includes("parent");
    },
    postHasContent() {
      const f = this.postForm;
      return !!(
        (f.title && f.title.trim()) ||
        (f.description && f.description.trim()) ||
        f.images.length ||
        f.newImages.length ||
        f.links.some((l) => l.url && l.url.trim()) ||
        (f.pollOn && f.poll.question.trim() && f.poll.options.filter((o) => o.trim()).length >= 2)
      );
    },
  },
  created() {
    if (!this.allowed) return;
    this.loadRoles();
    this.loadSchools();
    this.unsubMenus = fb.db
      .collection("_appMenus")
      .orderBy("order")
      .onSnapshot((snap) => {
        const list = [];
        snap.forEach((doc) => {
          const x = doc.data();
          if (x.deleted === true) return;
          if (this.mySchoolId) {
            if (x.schoolId && x.schoolId !== this.mySchoolId) return;
            const me = this.$store.state.userData;
            const mine = x.createdByRef && me.ref && x.createdByRef.path === me.ref.path;
            const groupAdmin = me.ref && (x.adminIds || []).includes(me.ref.id);
            if (!mine && !groupAdmin) {
              if (x.isPublic !== true) return;
              if ((x.roles || []).length && !x.roles.includes(me.role)) return;
            }
          }
          list.push({ id: doc.id, ref: doc.ref, ...x });
        });
        this.menus = list;
        this.loading = false;
        if (this.selected) {
          this.selected = list.find((m) => m.id === this.selected.id) || null;
          if (!this.selected) {
            this.contentDialog = false;
            this.watchPosts(null);
          }
        }
      });
  },
  beforeDestroy() {
    if (this.unsubMenus) this.unsubMenus();
    if (this.unsubPosts) this.unsubPosts();
    if (this.unsubComments) this.unsubComments();
  },
  methods: {
    async loadRoles() {
      const snap = await fb.db.collection("xDuties").where("isEmployee", "==", true).get();
      const seen = new Set();
      const roles = [];
      snap.forEach((doc) => {
        const x = doc.data();
        const role = (x.role || "").trim();
        if (!role || seen.has(role)) return;
        seen.add(role);
        roles.push({ role, name: (x.name || x.roleName || role).trim() });
      });
      roles.sort((a, b) => a.name.localeCompare(b.name, "mn"));
      this.roleItems = [
        { role: "_all", name: "Бүгд" },
        { role: "student", name: "Сурагч" },
        { role: "parent", name: "Эцэг эх" },
        { role: "teacher", name: "Багш" },
        ...roles,
      ];
    },
    // Remember the colour at open so Болих can put it back after trying others.
    toggleColor(form, key, open) {
      if (open) this.colorBackup = form[key];
      this.$set(this.colorMenu, key, open);
    },
    closeColor(key) {
      this.$set(this.colorMenu, key, false);
    },
    // Photos come from the person's own document, so a changed photo shows at once.
    photoOf(post) {
      return post.createdByRef ? this.authorPhotos[post.createdByRef.path] || "" : "";
    },
    // Same like / comment documents the app writes, so counts stay in step.
    loadMyLikes(posts) {
      const me = this.$store.state.userData;
      if (!me || !me.ref) return;
      posts.forEach((p) => {
        if (p.id in this.likedMap) return;
        this.$set(this.likedMap, p.id, false);
        p.ref
          .collection("liked")
          .doc(me.ref.id)
          .get()
          .then((doc) => this.$set(this.likedMap, p.id, doc.exists));
      });
    },
    loadMyVotes(posts) {
      const me = this.$store.state.userData;
      if (!me || !me.ref) return;
      posts.forEach((p) => {
        if (!p.poll || p.id in this.myVotes) return;
        this.$set(this.myVotes, p.id, []);
        p.ref
          .collection("pollVotes")
          .doc(me.ref.id)
          .get()
          .then((doc) => this.$set(this.myVotes, p.id, (doc.exists && doc.data().choices) || []));
      });
    },
    // Same as the app: tapping a chosen option again takes the vote back.
    async vote(post, index) {
      const me = this.$store.state.userData;
      if (!me || !me.ref || !post.poll || post.poll.closed || this.voting) return;
      const mine = this.myVotes[post.id] || [];
      let next;
      if (post.poll.multiple) next = mine.includes(index) ? mine.filter((i) => i !== index) : [...mine, index];
      else next = mine.includes(index) ? [] : [index];
      const voteRef = post.ref.collection("pollVotes").doc(me.ref.id);
      const display = String(me.DISPLAY_NAME || "").trim();
      const last = String(me.LAST_NAME || me.lastName || "");
      const name = display || (last ? last.charAt(0) + "." : "") + String(me.FIRST_NAME || me.firstName || "");
      this.voting = true;
      try {
        await fb.db.runTransaction(async (tx) => {
          const postSnap = await tx.get(post.ref);
          const voteSnap = await tx.get(voteRef);
          const poll = (postSnap.data() || {}).poll || {};
          const counts = (poll.options || []).map((_, i) => Number((poll.counts || [])[i]) || 0);
          const old = voteSnap.exists ? voteSnap.data().choices || [] : [];
          old.forEach((i) => {
            if (counts[i] > 0) counts[i]--;
          });
          next.forEach((i) => {
            if (i < counts.length) counts[i]++;
          });
          let voters = Number(poll.voters) || 0;
          if (!old.length && next.length) voters++;
          if (old.length && !next.length && voters > 0) voters--;
          tx.update(post.ref, { "poll.counts": counts, "poll.voters": voters });
          if (next.length) {
            tx.set(voteRef, {
              choices: next,
              userId: me.ref.id,
              name,
              role: me.role || null,
              at: fb.firestore.FieldValue.serverTimestamp(),
            });
          } else {
            tx.delete(voteRef);
          }
        });
        this.$set(this.myVotes, post.id, next);
      } catch (e) {
        this.$swal.fire("", "Санал өгч чадсангүй: " + e.message, "error");
      } finally {
        this.voting = false;
      }
    },
    async toggleLike(post) {
      const me = this.$store.state.userData;
      if (!me || !me.ref) return;
      const likeRef = post.ref.collection("liked").doc(me.ref.id);
      const liked = !!this.likedMap[post.id];
      this.$set(this.likedMap, post.id, !liked);
      if (liked) {
        await likeRef.delete();
        await post.ref.update({ totalLikes: fb.firestore.FieldValue.increment(-1) });
        return;
      }
      await likeRef.set({
        userId: me.ref.id,
        userRef: me.ref,
        role: me.role || null,
        schoolId: (me.school && me.school.id) || null,
        schoolName: (me.school && me.school.name) || "",
        fromMobile: false,
        FIRST_NAME: me.FIRST_NAME || me.firstName || null,
        LAST_NAME: me.LAST_NAME || me.lastName || null,
        createdAt: new Date(),
      });
      await post.ref.update({ totalLikes: fb.firestore.FieldValue.increment(1) });
    },
    async sendComment() {
      const me = this.$store.state.userData;
      const text = (this.commentText || "").trim();
      if (!me || !me.ref || !text || !this.commentsPost) return;
      this.sendingComment = true;
      try {
        await this.commentsPost.ref.collection("comments").add({
          text,
          authorId: me.ref.id,
          authorName: this.userLabel(),
          authorPhotoUrl: me.photoURL || "",
          FIRST_NAME: me.FIRST_NAME || me.firstName || null,
          role: me.role || null,
          createdAt: new Date(),
        });
        await this.commentsPost.ref.update({ totalComments: fb.firestore.FieldValue.increment(1) });
        this.commentText = "";
      } finally {
        this.sendingComment = false;
      }
    },
    loadAuthorPhotos(posts) {
      const refs = {};
      posts.forEach((p) => {
        if (p.createdByRef && !(p.createdByRef.path in this.authorPhotos)) refs[p.createdByRef.path] = p.createdByRef;
      });
      Object.keys(refs).forEach((path) => {
        this.$set(this.authorPhotos, path, "");
        refs[path].get().then((doc) => this.$set(this.authorPhotos, path, (doc.data() || {}).photoURL || ""));
      });
    },
    feedCardStyle(post) {
      const m = this.selected || {};
      return {
        background: post.bgColor || m.cardBgColor || "#fff",
        color: post.textColor || (post.bgColor ? this.contrastOf(post.bgColor) : m.cardTextColor || "#1e293b"),
      };
    },
    // Dark text on a light background, white on a dark one.
    contrastOf(hex) {
      const v = parseInt(String(hex).replace("#", "").slice(0, 6), 16);
      const lum = (0.299 * (v >> 16) + 0.587 * ((v >> 8) & 255) + 0.114 * (v & 255)) / 255;
      return lum > 0.6 ? "#1E293B" : "#FFFFFF";
    },
    feedTitleStyle(post) {
      const m = this.selected || {};
      return {
        fontSize: (post.titleSize || m.titleSize || 16) + 2 + "px",
        fontWeight: post.titleWeight || m.titleWeight || 700,
      };
    },
    linkColor(url) {
      const u = String(url || "").toLowerCase();
      if (u.includes("youtube.com") || u.includes("youtu.be")) return "#FF0000";
      if (u.includes("docs.google.com/presentation")) return "#FF9900";
      if (u.includes("drive.google.com")) return "#1A73E8";
      if (u.includes(".pdf")) return "#D93025";
      return "#2563EB";
    },
    openUrl(url) {
      window.open(url, "_blank");
    },
    pollPct(poll, i) {
      const voters = poll.voters || 0;
      return voters ? Math.round((((poll.counts || [])[i] || 0) * 100) / voters) : 0;
    },
    // What the app will use when the post sets no colour of its own.
    inheritedColor(c) {
      const m = this.selected || {};
      return c.key === "bgColor" ? m.cardBgColor || "#FFFFFF" : m.cardTextColor || "#1E293B";
    },
    userLabel() {
      const u = this.$store.state.userData || {};
      return (u.DISPLAY_NAME || u.FIRST_NAME || u.firstName || u.email || "").toString();
    },
    avatarColor(id) {
      return chatAvatarColor(id);
    },
    initialOf(c) {
      return String(c.FIRST_NAME || c.authorName || "?").trim().charAt(0).toUpperCase();
    },
    openComments(post) {
      if (!this.commentsPost || this.commentsPost.id !== post.id) this.commentLimit = 50;
      this.commentsPost = post;
      this.commentsDialog = true;
      if (this.unsubComments) this.unsubComments();
      this.comments = [];
      this.unsubComments = post.ref
        .collection("comments")
        .orderBy("createdAt", "desc")
        .limit(this.commentLimit)
        .onSnapshot((snap) => {
          const list = [];
          snap.forEach((doc) => {
            if (doc.data().deleted !== true) list.push({ id: doc.id, ref: doc.ref, ...doc.data() });
          });
          this.comments = list.reverse();
        });
    },
    async removeComment(c) {
      const result = await this.$swal.fire({
        title: "Сэтгэгдлийг устгах уу?",
        text: c.text,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Устгах",
        cancelButtonText: "Болих",
        customClass: {
          confirmButton: "btn bg-gradient-danger",
          cancelButton: "btn bg-gradient-light",
        },
      });
      if (!result.isConfirmed) return;
      await c.ref.update({
        deleted: true,
        deletedAt: new Date(),
        deletedByRef: this.$store.state.userData.ref,
        deletedByName: this.userLabel(),
      });
      await this.commentsPost.ref.update({ totalComments: fb.firestore.FieldValue.increment(-1) });
    },
    onRolesChange(val) {
      const last = val[val.length - 1];
      const roles = last === "_all" ? ["_all"] : val.filter((r) => r !== "_all");
      this.menuForm.roles = roles.length ? roles : ["_all"];
    },
    canApprove(menu) {
      if (this.isSuper || this.canEdit(menu)) return true;
      const me = this.$store.state.userData.ref;
      return !!(menu && me && (menu.adminIds || []).includes(me.id));
    },
    async loadClassGroups(schoolId) {
      this.classGroupItems = [];
      if (!schoolId) return;
      const year = this.$store.state.kSchoolStartYear;
      const snap = await fb.db.collection("schools").doc(schoolId).collection("classGroups-" + year).get();
      const list = [];
      snap.forEach((doc) => {
        const x = doc.data();
        if (x.deleted === true) return;
        const instructorId = x.INSTRUCTOR_ID != null ? x.INSTRUCTOR_ID : x.TEACHER_ID;
        list.push({
          id: String(x.STUDENT_GROUP_ID || doc.id),
          name: x.STUDENT_GROUP_NAME || x.name || doc.id,
          level: Number(x.ACADEMIC_LEVEL) || 0,
          instructorId: instructorId == null ? null : String(instructorId),
        });
      });
      list.sort((a, b) => a.level - b.level || a.name.localeCompare(b.name, "mn"));
      this.classGroupItems = list;
    },
    async loadStaff(schoolId) {
      this.loadClassGroups(schoolId);
      this.staffItems = [];
      if (!schoolId) return;
      this.staffLoading = true;
      try {
        const snap = await fb.db.collection("schools").doc(schoolId).collection("teachers").get();
        const list = [];
        snap.forEach((doc) => {
          const x = doc.data();
          if (x.deleted === true || x.moved === true || x.role === "student" || x.role === "parent") return;
          const first = (x.FIRST_NAME || x.firstName || "").toString().trim();
          const last = (x.LAST_NAME || x.lastName || "").toString().trim();
          const display = (x.DISPLAY_NAME || "").toString().trim();
          // Leftover stubs (only myClassInfo-xxxx) have no name and are not accounts.
          if (!first && !display && !x.email) return;
          const role = (this.roleItems.find((r) => r.role === x.role) || {}).name || x.role || "";
          const name = first ? `${last ? last[0] + "." : ""}${first}` : display || x.email;
          list.push({
            id: doc.id,
            name: `${name}${role ? " · " + role : ""}`,
            instructorId: x.INSTRUCTOR_ID == null ? null : String(x.INSTRUCTOR_ID),
          });
        });
        list.sort((a, b) => a.name.localeCompare(b.name, "mn"));
        this.staffItems = list;
      } finally {
        this.staffLoading = false;
      }
    },
    canEditPost(post) {
      return this.canEdit(post) || this.canApprove(this.selected);
    },
    // superadmin/2, the poll's author and the group's admins always see the results.
    seePollResults(post) {
      const poll = post.poll || {};
      return this.canEditPost(post) || !!poll.showResults || !!poll.closed || (this.myVotes[post.id] || []).length > 0;
    },
    async approvePost(post) {
      const now = new Date();
      const user = this.$store.state.userData;
      await post.ref.update({
        isPublished: true,
        status: "approved",
        publishedAt: now,
        approvedAt: now,
        approvedByRef: user.ref,
        approvedByName: this.userLabel(),
        updatedAt: now,
        updatedByRef: user.ref,
        updatedByName: this.userLabel(),
      });
      await this.selected.ref.update({ pendingCount: fb.firestore.FieldValue.increment(-1) });
    },
    async rejectPost(post) {
      const result = await this.$swal.fire({
        title: " Пост буцаах уу?",
        text: post.title || "",
        input: "text",
        inputPlaceholder: "Шалтгаан (заавал биш)",
        showCancelButton: true,
        confirmButtonText: "Буцаах",
        cancelButtonText: "Болих",
        customClass: {
          confirmButton: "btn bg-gradient-danger",
          cancelButton: "btn bg-gradient-light",
        },
      });
      if (!result.isConfirmed) return;
      const now = new Date();
      await post.ref.update({
        status: "rejected",
        isPublished: false,
        rejectReason: result.value || null,
        rejectedAt: now,
        rejectedByRef: this.$store.state.userData.ref,
        rejectedByName: this.userLabel(),
      });
      await this.selected.ref.update({ pendingCount: fb.firestore.FieldValue.increment(-1) });
    },
    canEdit(doc) {
      if (this.isSuper) return true;
      const me = this.$store.state.userData.ref;
      return !!(doc && doc.createdByRef && me && doc.createdByRef.path === me.path);
    },
    async loadSchools() {
      if (this.mySchoolId) {
        const school = this.$store.state.userData.school;
        this.schools = [{ id: school.id, name: school.name || school.id }];
        return;
      }
      // Only schools that switched the feature on; others never show these menus.
      const [snap, flags] = await Promise.all([
        fb.db.collection("schools").get(),
        fb.db.collection("_schoolDatas").where("appMenusEnabled", "==", true).get(),
      ]);
      const enabled = new Set(flags.docs.map((d) => d.id));
      const list = [];
      snap.forEach((doc) => {
        const x = doc.data();
        if (x.deleted === true || !enabled.has(doc.id)) return;
        list.push({ id: doc.id, name: x.name || doc.id });
      });
      list.sort((a, b) => a.name.localeCompare(b.name, "mn"));
      this.schools = list;
    },
    schoolFolder(menu) {
      if (!menu.schoolId) return "_global";
      return `${menu.schoolId}-${menu.schoolName || ""}`;
    },
    mdiOf(key) {
      const item = this.iconItems.find((i) => i.key === key);
      return item ? item.mdi : "mdi-text-box-outline";
    },
    // Resize in the browser so icons and photos don't go up at camera size.
    async shrinkImage(file, maxSide, quality = 0.85) {
      const bitmap = await createImageBitmap(file, { imageOrientation: "from-image" });
      const scale = Math.min(1, maxSide / Math.max(bitmap.width, bitmap.height));
      if (scale === 1 && file.size < 400 * 1024) return file;
      const canvas = document.createElement("canvas");
      canvas.width = Math.round(bitmap.width * scale);
      canvas.height = Math.round(bitmap.height * scale);
      canvas.getContext("2d").drawImage(bitmap, 0, 0, canvas.width, canvas.height);
      const png = file.type === "image/png";
      const blob = await new Promise((resolve) => canvas.toBlob(resolve, png ? "image/png" : "image/jpeg", quality));
      return new File([blob], file.name.replace(/\.[^.]+$/, png ? ".png" : ".jpg"), { type: blob.type });
    },
    pickIcon(event) {
      const file = event.target.files && event.target.files[0];
      event.target.value = "";
      if (!file) return;
      this.menuForm.newIcon = { file, preview: URL.createObjectURL(file) };
    },
    chipStyle(menu) {
      return {
        background: menu.bgColor || "#eef2f7",
        color: menu.textColor || "#1e293b",
      };
    },
    rolesLabel(menu) {
      const roles = menu.roles || [];
      const who = roles.length
        ? roles.map((r) => (this.roleItems.find((o) => o.role === r) || {}).name || r).join(", ")
        : "Бүгд";
      const grades = this.gradesLabel(menu.grades);
      const classes = (menu.classGroups || []).map((c) => c.name).join(", ");
      return [who, grades, classes].filter(Boolean).join(" · ");
    },
    // [6,7,8,9,10,11] -> "6-11 анги", [1,2,5] -> "1-2, 5 анги"
    gradesLabel(list) {
      const g = [...new Set((list || []).map(Number))].sort((a, b) => a - b);
      if (!g.length) return "";
      const parts = [];
      let start = g[0];
      let prev = g[0];
      for (const n of g.slice(1).concat([null])) {
        if (n === prev + 1) {
          prev = n;
          continue;
        }
        parts.push(start === prev ? `${start}` : `${start}-${prev}`);
        start = n;
        prev = n;
      }
      return parts.join(", ") + " анги";
    },
    // Picking a class group makes its class teacher an admin of the menu.
    classTeacherIds(groupIds) {
      const ids = [];
      (groupIds || []).forEach((gid) => {
        const g = this.classGroupItems.find((c) => c.id === gid);
        if (!g || !g.instructorId) return;
        const teacher = this.staffItems.find((t) => t.instructorId === g.instructorId);
        if (teacher && !ids.includes(teacher.id)) ids.push(teacher.id);
      });
      return ids;
    },
    addClassTeachers(groupIds) {
      this.menuForm.adminIds = [...new Set([...(this.menuForm.adminIds || []), ...this.classTeacherIds(groupIds)])];
    },
    // Back to "by grade": the class teachers that came with the groups leave the admin list.
    dropClassTeachers() {
      const auto = this.classTeacherIds(this.menuForm.classGroups);
      this.menuForm.adminIds = (this.menuForm.adminIds || []).filter((id) => !auto.includes(id));
    },
    removeAdmin(id) {
      if (this.lockedAdminIds.includes(id)) return;
      this.menuForm.adminIds = (this.menuForm.adminIds || []).filter((x) => x !== id);
    },
    toggleGrade(grade) {
      const i = this.menuForm.grades.indexOf(grade);
      if (i >= 0) this.menuForm.grades.splice(i, 1);
      else this.menuForm.grades.push(grade);
    },
    // v-color-picker emits {hex, hexa, ...} or a string; keep a 7-char hex.
    colorOf(value) {
      const raw = typeof value === "string" ? value : value && (value.hex || value.hexa);
      return raw ? String(raw).slice(0, 7).toUpperCase() : null;
    },
    youtubeId(url) {
      const match = String(url || "").match(
        /(?:youtube\.com\/(?:watch\?(?:.*&)?v=|shorts\/|embed\/|live\/)|youtu\.be\/)([\w-]{11})/,
      );
      return match ? match[1] : null;
    },
    // Same rule as the app: no pictures, the first YouTube link plays in the
    // post even when other links sit beside it.
    videoLink(post) {
      if ((post.images || []).length) return null;
      return (post.links || []).find((l) => !!this.youtubeId(l.url)) || null;
    },
    otherLinks(post) {
      const video = this.videoLink(post);
      return (post.links || []).filter((l) => l !== video);
    },
    linkIcon(url) {
      const u = String(url || "").toLowerCase();
      if (u.includes("youtu")) return "mdi-youtube";
      if (u.includes("drive.google") || u.includes("docs.google")) return "mdi-google-drive";
      return "mdi-link";
    },
    dateOf(value) {
      if (!value) return "-";
      const date = value.toDate ? value.toDate() : new Date(value);
      return moment(date).format("YYYY-MM-DD HH:mm");
    },
    // Newest 30 live; "more" widens the window by 30.
    loadMorePosts() {
      this.postLimit += 30;
      this.watchPosts(this.selected);
    },
    loadMoreComments() {
      this.commentLimit += 50;
      this.openComments(this.commentsPost);
    },
    selectMenu(menu) {
      this.selected = menu;
      this.postLimit = 30;
      this.watchPosts(menu);
      this.postTab = menu.pendingCount > 0 && this.canApprove(menu) ? 1 : 0;
      this.contentDialog = true;
    },
    watchPosts(menu) {
      if (this.unsubPosts) this.unsubPosts();
      this.unsubPosts = null;
      this.posts = [];
      if (!menu) return;
      this.unsubPosts = menu.ref
        .collection("posts")
        .orderBy("createdAt", "desc")
        .limit(this.postLimit)
        .onSnapshot((snap) => {
          const list = [];
          snap.forEach((doc) => {
            if (doc.data().deleted !== true) list.push({ id: doc.id, ref: doc.ref, ...doc.data() });
          });
          this.posts = list;
          this.loadAuthorPhotos(list);
          this.loadMyLikes(list);
          this.loadMyVotes(list);
        });
    },
    openMenu(menu) {
      this.loadStaff(menu ? menu.schoolId : this.mySchoolId);
      this.menuForm = menu
        ? {
            id: menu.id,
            name: menu.name || "",
            bgColor: menu.bgColor || null,
            textColor: menu.textColor || null,
            isPublic: !!menu.isPublic,
            roles: (menu.roles || []).length ? menu.roles : ["_all"],
            grades: (menu.grades || []).map(Number),
            adminIds: [...(menu.adminIds || [])],
            byGroups: (menu.classGroups || []).length > 0,
            classGroups: (menu.classGroups || []).map((c) => c.id),
            needApproval: menu.postPermission !== "members",
            layout: menu.layout || "list",
            schoolId: menu.schoolId || null,
            headerTitle: menu.headerTitle || "",
            icon: menu.icon || "article",
            iconUrl: menu.iconUrl || null,
            newIcon: null,
            gridColumns: menu.gridColumns || 2,
            imageRatio: menu.imageRatio || "wide",
            pageBgColor: menu.pageBgColor || null,
            cardBgColor: menu.cardBgColor || null,
            cardTextColor: menu.cardTextColor || null,
            titleSize: menu.titleSize || 16,
            titleWeight: menu.titleWeight || 700,
            titleMaxLines: menu.titleMaxLines || 2,
            appBarColor: menu.appBarColor || null,
            appBarTextColor: menu.appBarTextColor || null,
          }
        : {
            id: null,
            name: "",
            bgColor: null,
            textColor: null,
            isPublic: false,
            roles: ["_all"],
            grades: [],
            byGroups: false,
            classGroups: [],
            adminIds: [],
            needApproval: true,
            layout: "list",
            schoolId: this.mySchoolId,
            headerTitle: "",
            icon: "article",
            iconUrl: null,
            newIcon: null,
            gridColumns: 2,
            imageRatio: "wide",
            pageBgColor: null,
            cardBgColor: null,
            cardTextColor: null,
            titleSize: 16,
            titleWeight: 700,
            titleMaxLines: 2,
            appBarColor: null,
            appBarTextColor: null,
          };
      this.menuDialog = true;
    },
    async saveMenu() {
      const f = this.menuForm;
      this.saving = true;
      try {
        const schoolId = this.isSuper ? f.schoolId || null : this.mySchoolId;
        const data = {
          name: f.name.trim(),
          bgColor: f.bgColor || null,
          textColor: f.textColor || null,
          isPublic: !!f.isPublic,
          roles: (f.roles || []).includes("_all") ? [] : f.roles || [],
          adminIds: [...new Set([...(f.adminIds || []), ...this.lockedAdminIds])],
          // "By groups" targets the picked groups only (their grades follow); otherwise grades apply.
          classGroups:
            this.gradesApply && f.byGroups
              ? (f.classGroups || []).map((id) => {
                  const c = this.classGroupItems.find((x) => x.id === id);
                  return { id, name: c ? c.name : id, level: c ? c.level : 0 };
                })
              : [],
          grades: !this.gradesApply
            ? []
            : f.byGroups
              ? [...new Set((f.classGroups || []).map((id) => (this.classGroupItems.find((x) => x.id === id) || {}).level).filter(Boolean))].sort((a, b) => a - b)
              : [...(f.grades || [])].map(Number).sort((a, b) => a - b),
          postPermission: f.needApproval ? "approval" : "members",
          layout: f.layout || "list",
          schoolId,
          schoolName: schoolId ? (this.schools.find((sc) => sc.id === schoolId) || {}).name || null : null,
          schoolRef: schoolId ? fb.db.collection("schools").doc(schoolId) : null,
          headerTitle: (f.headerTitle || "").trim() || null,
          icon: f.icon || "article",
          iconUrl: f.iconUrl || null,
          gridColumns: f.gridColumns || 2,
          imageRatio: f.imageRatio || "wide",
          pageBgColor: f.pageBgColor || null,
          cardBgColor: f.cardBgColor || null,
          cardTextColor: f.cardTextColor || null,
          titleSize: f.titleSize || 16,
          titleWeight: f.titleWeight || 700,
          titleMaxLines: f.titleMaxLines || 2,
          appBarColor: f.appBarColor || null,
          appBarTextColor: f.appBarTextColor || null,
          updatedAt: new Date(),
          updatedByRef: this.$store.state.userData.ref,
          updatedByName: this.userLabel(),
        };
        if (f.newIcon) {
          const folder = this.schoolFolder({ schoolId, schoolName: data.schoolName });
          const icon = await this.shrinkImage(f.newIcon.file, 160);
          const path = `_appMenus/${folder}/${data.name}/icon-${Date.now()}-${icon.name}`;
          data.iconUrl = await fb.uploadToStorageGlobal(path, icon);
        }
        if (f.id) {
          await fb.db.collection("_appMenus").doc(f.id).update(data);
        } else {
          const last = this.menus.length ? this.menus[this.menus.length - 1].order || 0 : 0;
          await fb.db.collection("_appMenus").add({
            ...data,
            order: last + 1,
            postCount: 0,
            createdAt: new Date(),
            createdByRef: this.$store.state.userData.ref,
            createdByName: this.userLabel(),
          });
        }
        this.menuDialog = false;
      } catch (e) {
        this.$swal.fire({ icon: "error", title: "Хадгалж чадсангүй", text: String(e.message || e) });
      } finally {
        this.saving = false;
      }
    },
    async move(menu, dir) {
      const i = this.menus.indexOf(menu);
      const other = this.menus[i + dir];
      if (!other) return;
      const batch = fb.db.batch();
      batch.update(menu.ref, { order: i + dir + 1 });
      batch.update(other.ref, { order: i + 1 });
      await batch.commit();
    },
    async removeMenu(menu) {
      const result = await this.$swal.fire({
        title: menu.name + " цэсийг устгах уу?",
        text: "Доторх агуулга нь хамт устана.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Устгах",
        cancelButtonText: "Болих",
        customClass: {
          confirmButton: "btn bg-gradient-danger",
          cancelButton: "btn bg-gradient-light",
        },
      });
      if (!result.isConfirmed) return;
      await menu.ref.update({
        deleted: true,
        isPublic: false,
        deletedAt: new Date(),
        deletedByRef: this.$store.state.userData.ref,
        deletedByName: this.userLabel(),
      });
      if (this.selected && this.selected.id === menu.id) {
        this.selected = null;
        this.watchPosts(null);
      }
    },
    openPost(post) {
      this.pollStats =
        post && post.poll
          ? { options: post.poll.options || [], counts: post.poll.counts || [], voters: post.poll.voters || 0 }
          : null;
      this.postForm = post
        ? {
            id: post.id,
            title: post.title || "",
            description: post.description || "",
            links: (post.links || []).map((l) => ({ title: l.title || "", url: l.url || "" })),
            images: [...(post.images || [])],
            newImages: [],
            bgColor: post.bgColor || null,
            textColor: post.textColor || null,
            titleSize: post.titleSize || "menu",
            titleMaxLines: post.titleMaxLines || "menu",
            titleWeight: post.titleWeight || "menu",
            isPublished: post.isPublished !== false,
            allowLikes: post.allowLikes !== false,
            allowComments: post.allowComments !== false,
            status: post.status || null,
            pollOn: !!post.poll,
            poll: post.poll
              ? {
                  question: post.poll.question || "",
                  options: [...(post.poll.options || [])],
                  multiple: !!post.poll.multiple,
                  anonymous: !!post.poll.anonymous,
                  showResults: !!post.poll.showResults,
                  closed: !!post.poll.closed,
                  bg: post.poll.bg || "",
                  text: post.poll.text || "",
                }
              : { question: "", options: ["", ""], multiple: false, anonymous: false, showResults: false, closed: false, bg: "", text: "" },
          }
        : {
            id: null,
            title: "",
            description: "",
            links: [],
            images: [],
            newImages: [],
            bgColor: null,
            textColor: null,
            titleSize: "menu",
            titleMaxLines: "menu",
            titleWeight: "menu",
            isPublished: true,
            allowLikes: true,
            allowComments: true,
            status: null,
            pollOn: false,
            poll: { question: "", options: ["", ""], multiple: false, anonymous: false, showResults: false, closed: false, bg: "", text: "" },
          };
      if (!this.pollPresets.length) pollColorPresets().then((list) => (this.pollPresets = list));
      this.postDialog = true;
    },
    pickImages(event) {
      const files = Array.from(event.target.files || []);
      event.target.value = "";
      for (const file of files) {
        this.postForm.newImages.push({ file, preview: URL.createObjectURL(file) });
      }
    },
    async savePost() {
      const f = this.postForm;
      const menu = this.selected;
      const user = this.$store.state.userData;
      this.saving = true;
      try {
        const now = new Date();
        const data = {
          title: f.title.trim() || null,
          description: f.description.trim() || null,
          links: f.links
            .filter((l) => l.url && l.url.trim())
            .map((l) => ({ title: (l.title || "").trim(), url: l.url.trim() })),
          bgColor: f.bgColor || null,
          textColor: f.textColor || null,
          titleSize: f.titleSize === "menu" ? null : f.titleSize,
          titleMaxLines: f.titleMaxLines === "menu" ? null : f.titleMaxLines,
          titleWeight: f.titleWeight === "menu" ? null : f.titleWeight,
          isPublished: !!f.isPublished,
          allowLikes: !!f.allowLikes,
          allowComments: !!f.allowComments,
          updatedAt: now,
          updatedByRef: user.ref,
          updatedByName: this.userLabel(),
        };
        // Poll options keep their counts by position; new options start at 0.
        const pollOptions = f.pollOn ? f.poll.options.map((o) => String(o || "").trim()).filter(Boolean) : [];
        const pollQuestion = f.pollOn ? String(f.poll.question || "").trim() : "";
        data.poll =
          pollQuestion && pollOptions.length >= 2
            ? {
                question: pollQuestion,
                options: pollOptions,
                multiple: !!f.poll.multiple,
                anonymous: !!f.poll.anonymous,
                showResults: !!f.poll.showResults,
                closed: !!f.poll.closed,
                ...(f.poll.bg ? { bg: f.poll.bg, text: f.poll.text } : {}),
                counts: pollOptions.map((_, i) => ((this.pollStats && this.pollStats.counts) || [])[i] || 0),
                voters: (this.pollStats && this.pollStats.voters) || 0,
              }
            : null;
        // Admins publish as they like; a member's post (new or edited) waits for approval
        // unless the group publishes members' posts directly.
        const admin = this.canApprove(menu);
        let pendingDelta = 0;
        if (!admin) {
          if (menu.postPermission === "members") {
            data.isPublished = true;
            data.status = "approved";
          } else {
            data.isPublished = false;
            data.status = "pending";
            if (!f.id || f.status !== "pending") pendingDelta = 1;
          }
        } else if (f.id && f.status === "pending" && f.isPublished) {
          data.status = "approved";
          pendingDelta = -1;
        }
        let ref;
        if (f.id) {
          ref = menu.ref.collection("posts").doc(f.id);
          await ref.update({ ...data, images: f.images });
        } else {
          ref = await menu.ref.collection("posts").add({
            ...data,
            images: [],
            status: data.status || "approved",
            totalLikes: 0,
            totalComments: 0,
            publishedAt: data.isPublished ? now : null,
            createdAt: now,
            createdById: user.ref.id,
            createdByRef: user.ref,
            createdByName: this.userLabel(),
            createdByRole: user.role || null,
            schoolId: (user.school && user.school.id) || null,
          });
        }
        const urls = [...f.images];
        for (const img of f.newImages) {
          const file = await this.shrinkImage(img.file, 1600);
          const path = `_appMenus/${this.schoolFolder(menu)}/${menu.name}/${Date.now()}-${file.name}`;
          urls.push(await fb.uploadToStorageGlobal(path, file));
        }
        if (f.newImages.length) await ref.update({ images: urls });
        const counters = {};
        if (!f.id) counters.postCount = fb.firestore.FieldValue.increment(1);
        if (pendingDelta) counters.pendingCount = fb.firestore.FieldValue.increment(pendingDelta);
        if (Object.keys(counters).length) await menu.ref.update(counters);
        this.postDialog = false;
      } catch (e) {
        this.$swal.fire({ icon: "error", title: "Хадгалж чадсангүй", text: String(e.message || e) });
      } finally {
        this.saving = false;
      }
    },
    async removePost(post) {
      const result = await this.$swal.fire({
        title: "Агуулгыг устгах уу?",
        text: post.title || "",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Устгах",
        cancelButtonText: "Болих",
        customClass: {
          confirmButton: "btn bg-gradient-danger",
          cancelButton: "btn bg-gradient-light",
        },
      });
      if (!result.isConfirmed) return;
      await post.ref.update({
        deleted: true,
        isPublished: false,
        deletedAt: new Date(),
        deletedByRef: this.$store.state.userData.ref,
        deletedByName: this.userLabel(),
      });
      await this.selected.ref.update({
        postCount: fb.firestore.FieldValue.increment(-1),
        ...(post.status === "pending" ? { pendingCount: fb.firestore.FieldValue.increment(-1) } : {}),
      });
    },
  },
};
